module.exports = __webpack_public_path__ + "static/media/bg.c8c5eb0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg.png
// module id = 199
// module chunks = 0